import React, { useState, useEffect } from "react";
import {getStudentIdData, updateData, addData } from "../../../lib/studentlessons"
import { getDataWithClass } from "../../../lib/lessons"
import { useAuth } from "../../../usercontext";

export default function StudentLessonList() {
  const [lessonList, setLessonList] = useState([]);
  const [studentLessonList, setStudentLessonList] = useState([]);
  const { profile } = useAuth();

  //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
  const slug = profile.id;
  const cls =  profile.class;

  function getStudentData(lesson) {

    if (studentLessonList.length > 0) {
      //console.log("studentLessonList", studentLessonList);
      const result = studentLessonList.filter(item => item.lessonId === lesson);

      //console.log("result", result);
      return result.length > 0 ? result[0].id : 0;
    }
    else
      return 0;
  }

  function getStudentLesson(lesson) {

    if (studentLessonList.length > 0) {
      //console.log("studentLessonList", studentLessonList);
      const result = studentLessonList.filter(item => item.lessonId === lesson);

      //console.log("result", result);
      let returnresult =  false;

      if (result.length > 0 )
        returnresult =  result[0].isCheck;

        return returnresult;

     // return result.length > 0 ? true : 0;
    }
    else
      return false;
  }



  async function UpdateisCheck(Id, isCheck, lessonId) {

    /*
    if (isCheck !== null)
      isCheck = true
    else
      isCheck = false;
*/
    //Id doesnt exist you have to add
    if (Id == 0) {
      console.log("Add", Id, isCheck, lessonId);
      await addData({
        isCheck: !isCheck,
        studentId: slug,
        lessonId: lessonId
      });

    }
    else {
      console.log("Update", Id, isCheck, lessonId);
      await updateData({
        id: parseInt(Id),
        isCheck: !isCheck
      });

    }
    GetData();
  }


  function ChangeStatus(Id, isCheck,lessonId) {
    //console.log("Id",Id,isCheck,lessonId);
    /*
        const myNextList = [...lessonlist];
        const artwork = myNextList.find(
          a => a.id === Id
        );
        artwork.isCheck = !artwork.isCheck;
        console.log("myNextList",myNextList);
        setLessonList(myNextList);
    */
    UpdateisCheck(Id, isCheck, lessonId);
  }

  async function GetData() {

    const stbooks = await getStudentIdData(slug, cls);
    setStudentLessonList(stbooks);

    const books = await getDataWithClass(cls);
    setLessonList(books);

    //console.log("books", books);
  }

  useEffect(() => {
    GetData();
  }, [profile]);

  return (
            <div className="col-12">
              <div className="settings-widget profile-details">
                <div className="settings-inner-blk p-0">
                  <div className="profile-heading">
                    <h3>Lesson List</h3>

                  </div>
                  <div className="comman-space pb-0">
                    <div className="settings-invoice-blk table-responsive">
                      {/* Invoice info */}
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Lesson</th>
                            <th>Is Check</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            lessonList ? lessonList.map(function (data) {
                              return (
                                <tr key={data.id}>
                                  <td> {data.id} </td>
                                  <td>{data.lessonname}</td>
                                  <td><div className="form-check form-switch check-on">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={getStudentLesson(data.id)}
                                      onChange={(e) => ChangeStatus(getStudentData(data.id), getStudentLesson(data.id),data.id)}
                                    />
                                  </div></td>

                                </tr>
                              )
                            }) : ""}
                        </tbody>
                      </table>
                      {/* Invoice info */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
